export const COMPANY = {
  name: "DOPMAN",
  legal: "DOPMAN B.V.",
  since: "2021",
  motto: "Voor iedere klus, de juiste vakman.",
  address: "Industrieweg 102, 2254 AE Voorschoten",
  email: "info@dopman.nl",
  phone: "+31 6 43465124",
  phoneHref: "tel:+31643465124",
  whatsapp: "31643465124",
  kvk: "97665355",
  btw: "NL868168506B01",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  about: "/proj-8551.jpg",
  bathroom: "/proj-8562.jpg",
  plaster: "/proj-8569.jpg",
  renovation: "/proj-8550.jpg",
};

export const DIVISIONS = [
  {
    id: "afwerking",
    index: "01",
    title: "Badkamers, Keukens & Toiletten",
    tag: "Sanitair & Interieur",
    color: "var(--turq)",
    body: "Van complete badkamerrenovaties tot maatwerk keukens en toiletten. Vakmanschap tot in het kleinste detail — tegelwerk, sanitair, leidingwerk en afwerking onder één dak.",
    points: ["Complete badkamers", "Keukens op maat", "Toiletruimtes", "Tegel- & sanitairwerk"],
    image: IMG.bathroom,
  },
  {
    id: "stuc",
    index: "02",
    title: "Stucwerk, Schilderwerk & Glas",
    tag: "Afbouw & Finishing",
    color: "var(--orange)",
    body: "Strak stucwerk, duurzaam schilderwerk binnen en buiten en vakkundig glaszetten. De laag die het verschil maakt tussen af en écht afgewerkt.",
    points: ["Stucwerk & spachtelputz", "Binnen- & buitenschilderwerk", "Glas zetten", "Wandafwerking"],
    image: IMG.plaster,
  },
  {
    id: "renovatie",
    index: "03",
    title: "Renovatie & Onderhoud",
    tag: "Algemeen",
    color: "var(--blue)",
    body: "Van grondige verbouwingen tot planmatig onderhoud. Wij houden uw pand in topconditie — praktisch, betrouwbaar en met oog voor de lange termijn.",
    points: ["Verbouwingen", "Planmatig onderhoud", "Herstelwerk", "Advies & begeleiding"],
    image: IMG.renovation,
  },
];

export const PROCESS = [
  { n: "01", title: "Kennismaking & inspectie", body: "We komen langs, luisteren naar uw wensen en brengen het werk nauwkeurig in kaart." },
  { n: "02", title: "Offerte & planning", body: "Een heldere, transparante offerte met een realistische planning — geen verrassingen achteraf." },
  { n: "03", title: "Uitvoering door vakmensen", body: "Als hoofdaannemer coördineren wij elke fase, van fundament tot eindafwerking." },
  { n: "04", title: "Oplevering & nazorg", body: "We leveren netjes op en blijven bereikbaar voor onderhoud en vragen." },
];

export const PORTFOLIO = [
  { img: "/proj-8551.jpg", title: "Maatwerk TV-wand met sfeerhaard", cat: "Afwerking & interieur", category: "Renovatie" },
  { img: "/proj-8562.jpg", title: "Marmerlook badkamer met inloopdouche", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-6771.jpg", title: "Badkamer met verlicht ronde spiegel", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-7499.jpg", title: "Keuken op maat met visgraatvloer", cat: "Keukens", category: "Keukens" },
  { img: "/proj-4335.jpg", title: "Antraciet keuken met sfeerverlichting", cat: "Keukens", category: "Keukens" },
  { img: "/proj-fsr.jpg", title: "Witte keuken met zwart werkblad", cat: "Keukens", category: "Keukens" },
  { img: "/proj-0069.jpg", title: "Zwarte keuken met eetgedeelte", cat: "Keukens", category: "Keukens" },
  { img: "/proj-9967.jpg", title: "Strakke witte keuken op maat", cat: "Keukens", category: "Keukens" },
  { img: "/proj-8550.jpg", title: "Zwevende eiken trap met LED", cat: "Renovatie & interieur", category: "Renovatie" },
  { img: "/proj-8539.jpg", title: "Badkamer in antracietlook", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-0042.jpg", title: "Luxe toilet in zwart marmer", cat: "Toiletten", category: "Toiletten" },
  { img: "/proj-8683.jpg", title: "Inloopdouche met zwart profiel", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-6666.jpg", title: "Strak gastentoilet", cat: "Toiletten", category: "Toiletten" },
  { img: "/proj-8569.jpg", title: "Gevelrenovatie & stucwerk", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/proj-2410.jpg", title: "Badkamer met ronde spiegel & inloopdouche", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-9973.jpg", title: "Witte badkamer met hoekdouche", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-2509.jpg", title: "Badkamer met ligbad en dakraam", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-2646.jpg", title: "Compacte badkamer met ligbad", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-9971.jpg", title: "Toiletruimte met douchehoek", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-2295.jpg", title: "Zolderbadkamer met zwart meubel", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-2591.jpg", title: "Badkamer met verlichte spiegel", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-6772.jpg", title: "Vrijstaand bad met regendouche", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-2585.jpg", title: "Ruime zolderbadkamer", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-6681.jpg", title: "Inloopdouche & zwevend toilet", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-2641.jpg", title: "Badkamer met ligbad en regendouche", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-775d.jpg", title: "Toilet in marmerlook met zwart sanitair", cat: "Toiletten", category: "Toiletten" },
  { img: "/proj-5580.jpg", title: "Toiletruimte in antraciet", cat: "Toiletten", category: "Toiletten" },
  { img: "/proj-8804.jpg", title: "Inloopdouche met beige tegels", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-8805.jpg", title: "Badkamer met toilet en radiator", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-7789.jpg", title: "Badkamer met wasmachine-opstelling", cat: "Badkamers", category: "Badkamers" },
  { img: "/proj-8451.jpg", title: "Gevelrenovatie met nieuwe pui", cat: "Renovatie & onderhoud", category: "Renovatie" },
  { img: "/proj-8452.jpg", title: "Gerenoveerde hoekgevel", cat: "Renovatie & onderhoud", category: "Renovatie" },
  { img: "/schilder-05.jpg", title: "Voordeur in hoogglans lak", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-01.jpg", title: "Trap en spijlen strak geschilderd", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-02.jpg", title: "Vide met wit schilderwerk", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-03.jpg", title: "Strak schilderwerk in de woonkeuken", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-04.jpg", title: "Zolder en trap in wit schilderwerk", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-06.jpg", title: "Klassieke voordeur in crème lak", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-09.jpg", title: "Wanden strak stucen", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-08.jpg", title: "Woonkamer voorbereid voor schilderwerk", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-10.jpg", title: "Afgewerkte kamer met stucwerk & lakwerk", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
  { img: "/schilder-07.jpg", title: "Machinaal stucwerk met Knauf MP75", cat: "Stucwerk & schilderwerk", category: "Stucwerk & schilderwerk" },
];

export const PROJECTS = [
  {
    id: "woningrenovatie-1",
    title: "Complete woningrenovatie",
    subtitle: "Van gedateerd naar tijdloos",
    location: "Particuliere woning",
    year: "2024",
    description:
      "Een volledige renovatie van fundament tot eindafwerking. De authentieke balken bleven behouden en kregen een frisse uitstraling, met een nieuwe visgraatvloer, strak stucwerk en een lichte, tijdloze afwerking door het hele huis.",
    after: [
      "/proj-0458.jpg",
      "/proj-0428.jpg",
      "/proj-0432.jpg",
      "/proj-0429.jpg",
      "/proj-0462.jpg",
      "/proj-0431.jpg",
      "/proj-0430.jpg",
      "/proj-0463.jpg",
      "/proj-0466.jpg",
      "/proj-0467.jpg",
      "/proj-0468.jpg",
      "/proj-0464.jpg",
      "/proj-0473.jpg",
      "/proj-0469.jpg",
      "/proj-0470.jpg",
      "/proj-0472.jpg",
      "/proj-0474.jpg",
      "/proj-0475.jpg",
      "/proj-0476.jpg",
      "/proj-0477.jpg",
      "/proj-0478.jpg",
      "/proj-0479.jpg",
      "/proj-0480.jpg",
      "/proj-0483.jpg",
      "/proj-0481.jpg",
      "/proj-0482.jpg",
    ],
    before: [
      "/before-01.jpg",
      "/before-02.jpg",
      "/before-03.jpg",
      "/before-04.jpg",
      "/before-05.jpg",
      "/before-06.jpg",
      "/before-07.jpg",
      "/before-08.jpg",
      "/before-09.jpg",
      "/before-10.jpg",
      "/before-11.jpg",
      "/before-12.jpg",
      "/before-13.jpg",
      "/before-14.jpg",
      "/before-15.jpg",
      "/before-16.jpg",
      "/before-17.jpg",
      "/before-18.jpg",
      "/before-19.jpg",
      "/before-20.jpg",
      "/before-21.jpg",
      "/before-22.jpg",
      "/before-23.jpg",
      "/before-24.jpg",
      "/before-25.jpg",
      "/before-26.jpg",
      "/before-27.jpg",
      "/before-28.jpg",
      "/before-29.jpg",
    ],
  },
];

export const PORTFOLIO_CATEGORIES = ["Alles", "Badkamers", "Keukens", "Toiletten", "Renovatie", "Stucwerk & schilderwerk"];
